import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("p", null, "For support please email", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "ask@managemywedding.com", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, "(Tap again to open in mail app)", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { "default-href": "/tabs/home" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Settings')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, {
                button: "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push({path:'/tabs/home/settings/wedding'})))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { color: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Wedding Information')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_icon, {
                    slot: "end",
                    icon: _ctx.personCircleOutline
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, {
                button: "",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push({path: _ctx.store.state.premium.owned ? '/tabs/home/settings/planners' : '/tabs/bigday'})))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { color: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Planning Partners')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_icon, {
                    slot: "end",
                    icon: _ctx.personAddOutline
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, {
                button: "",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.router.push({path:'/tabs/home/settings/mydetails'})))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { color: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Edit My Details')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_icon, {
                    slot: "end",
                    icon: _ctx.personOutline
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, {
                button: "",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.router.push({path:'/tabs/home/settings/changepassword'})))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { color: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Change Password')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_icon, {
                    slot: "end",
                    icon: _ctx.lockClosedOutline
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, { href: "https://managemywedding.com/pages/terms-and-privacy" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { color: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Terms & Privacy')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_icon, {
                    slot: "end",
                    icon: _ctx.documentsOutline
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }),
              (_ctx.showSupportEmail)
                ? (_openBlock(), _createBlock(_component_ion_item, {
                    key: 0,
                    href: "mailto:ask@managemywedding.com"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { color: "primary" }, {
                        default: _withCtx(() => [
                          _hoisted_1,
                          _hoisted_2,
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_icon, {
                        slot: "end",
                        icon: _ctx.mail
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_ion_item, {
                    key: 1,
                    button: "",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showSupportEmail=true))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { color: "primary" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Help & Support')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_icon, {
                        slot: "end",
                        icon: _ctx.helpCircleOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })),
              _createVNode(_component_ion_item, {
                button: "",
                onClick: _ctx.onLogOut
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, { color: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Log Out')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_icon, {
                    slot: "end",
                    icon: _ctx.logOutOutline
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}